export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/array.js
// module id = 3s9O
// module chunks = 0